import React, { useState, useEffect, useMemo } from "react";
import '../../Payroll.css';
import { AgGridReact } from "ag-grid-react";
import { FormatDate, FormatUSD, CustomComparator } from "Components/CustomComponents/ValueFormatters/GridValueFormatters";

export default function AllOaps({
    oapRowData,
    leftoverOapList
}) {
    const [allOapRows, setAllOapRows] = useState();
    const [allOapColDefs, setAllOapColDefs] = useState();
    const [defaultColDef] = useState ({
        sortable: true,
        resizable: true,
        filter: true,      
    });

    useEffect(() => {
        if (oapRowData&&oapRowData.length) {
            let oapRows = [];
            oapRowData.forEach(oap => oap.OAPNumber.startsWith("OAP") ? oapRows.push(oap) : null);
            
            let allOaps = [];
            oapRows.forEach(oap => {
                let uniqueOapNumber = allOaps.find(customer => customer.OAPNumber === oap.OAPNumber);
                if (uniqueOapNumber === undefined) {
                    allOaps.push(oap);
                }
            })

            setAllOapRows(allOaps);
        };
        // eslint-disable-next-line
    },[oapRowData])

    useEffect(() => {
        if (allOapRows) {
            setAllOapColDefs([
                { field: "OAPNumber" },
                {
                    field: "DepositDate",
                    valueFormatter: (data) => FormatDate(data),
                },
                {
                    field: "ItemDate",
                    valueFormatter: (data) => FormatDate(data),
                },
                { field: "OAPAmount", valueFormatter: data => FormatUSD(data) },
                
                {
                    field: "CustomerName",
                    sort: 'asc',
                    comparator: CustomComparator
                }
            ]);
        }
        // eslint-disable-next-line
    }, [allOapRows]);
    
    const onFirstDataRendered = (params) => { 
        params.columnApi.autoSizeAllColumns();
    };
    
    const rowClassRules = useMemo(() => {
        if (oapRowData) {
            return {
                'leftover-overlay': params => {
                    var currentOapNumber = params.data.OAPNumber;
                    var leftoverOAP = leftoverOapList.find(oap => oap.OAPNumber === currentOapNumber);
                    return leftoverOAP;
                }, 
            };
        }
        // eslint-disable-next-line
    }, [oapRowData]);

    return (
        <>
            <h5>All OAPs</h5>
            <div className="ag-theme-alpine">
                <AgGridReact
                    rowData={allOapRows}
                    columnDefs={allOapColDefs}
                    defaultColDef={defaultColDef}
                    onFirstDataRendered={onFirstDataRendered}
                    rowClassRules={rowClassRules}
                />
            </div>
        </>
    )
}